import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Text } from '@mantine/core';
import { IconSettings, IconTrash } from '@tabler/icons-react';

import { useChangeFunnelsOrder } from '../../api/changeFunnelsOrder';
import { useGetFunnels } from '../../api/getFunnels';
import { useRemoveFunnel } from '../../api/removeFunnel';

import { AddFunnelModal } from './AddModal';
import { EditFunnelModal } from './EditModal';

import { AddButton } from '@/components';
import { ConfirmModal } from '@/components/Modals/Confirm';
import { useDragAndDrop } from '@/hooks/useDragAndDrop';

export const Funnels = ({ pageId }: { pageId: string }) => {
  const { data, isLoading } = useGetFunnels({ pageId });
  const { funnels = [] } = data || {};
  const { mutate } = useChangeFunnelsOrder({ pageId });
  const removeFunnel = useRemoveFunnel({ pageId });
  const { onDragStart, onDragOver, onDragLeave, onDragDrop } = useDragAndDrop();

  const handleDrop = (startIndex: number, dropIndex: number) => {
    if (dropIndex !== startIndex) {
      const newState = [...funnels];
      newState.splice(dropIndex, 0, newState.splice(startIndex, 1)[0]);
      const filteredIds = newState.map((item) => item._id);
      mutate(filteredIds);
    }
  };

  return (
    <>
      <Grid columns={3}>
        {funnels?.map((funnel, index) => (
          <Grid.Col
            span={1}
            key={funnel._id}
            draggable={true}
            onDragStart={() => onDragStart(index)}
            onDragOver={(e) => onDragOver(e)}
            onDrop={(e) => onDragDrop(e, (startIndex) => handleDrop(startIndex, index))}
            onDragLeave={(e) => onDragLeave(e)}
          >
            <Paper shadow="md" radius="md" pl="md" pr="sm" py="sm">
              <Group justify="space-between">
                <Text size="sm" color={funnel.color}>
                  {funnel.name}
                </Text>
                <Group>
                  <ActionIcon
                    variant="filled"
                    color="red"
                    onClick={() =>
                      NiceModal.show(ConfirmModal, {
                        title: `Remove funnel (${funnel.name})?`,
                        onSuccess: () => removeFunnel.mutate({ funnelId: funnel._id }),
                      })
                    }
                    radius="md"
                  >
                    <IconTrash />
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() =>
                      NiceModal.show(EditFunnelModal, {
                        pageId,
                        funnelId: funnel._id,
                        initialValues: { name: funnel.name, color: funnel.color },
                      })
                    }
                    radius="md"
                  >
                    <IconSettings />
                  </ActionIcon>
                </Group>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton isLoading={isLoading} onClick={() => NiceModal.show(AddFunnelModal, { pageId })} />
    </>
  );
};
